import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Table, Checkbox, Input, Space } from 'antd';
import debounce from 'lodash/debounce';
import { listUserPortfolios, addUserPortfolio, removeUserPortfolio } from '../../../Store/slices/superUser.slice';

const UserPortfolioManager = ({ userId, visible, onClose }) => {
  const dispatch = useDispatch();
  // Assuming you have a selector to get portfolioList from your Redux store
  const portfolioList = useSelector((state) => state.superuser.portfolioList);
  const userPortfolioIds = useSelector((state) => state.superuser.userPortfolios?.[userId]);
  const [selectedPortfolios, setSelectedPortfolios] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');




  useEffect(() => {
    if (visible) {
      dispatch(listUserPortfolios(userId));
    }
  }, [userId, visible, dispatch]);

  useEffect(() => {
    if (!userPortfolioIds) return;
    setSelectedPortfolios(userPortfolioIds);
  }, [userPortfolioIds]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Select',
      key: 'select',
      render: (_, record) => (
        <Checkbox
          checked={selectedPortfolios.includes(record.id)}
          onChange={(e) => handleSelect(e, record.id)}
        />
      ),
    },
  ];

  const handleSelect = (e, id) => {
    const checked = e.target.checked;
    setSelectedPortfolios(prev => checked ? [...prev, id] : prev.filter(portfolioId => portfolioId !== id));

    // Dispatch actions based on whether the portfolio is being added or removed
    if (checked) {
      dispatch(addUserPortfolio({ uid: userId, id, type: portfolioList.find(p => p.id === id).type }));
    } else {
      dispatch(removeUserPortfolio({ uid: userId, id }));
    }
  };

  // Sort portfolios by ones that are selected first
  const sortedPortfolioList = [...portfolioList].sort((a, b) => {
    const aIsSelected = selectedPortfolios.includes(a.id);
    const bIsSelected = selectedPortfolios.includes(b.id);
    return aIsSelected === bIsSelected ? 0 : aIsSelected ? -1 : 1;
  });

  const handleSearch = useCallback(debounce((term) => {
    setSearchTerm(term.toLowerCase());
  }, 500), []);

  // Filtered and sorted list based on search term
  const filteredAndSortedPortfolioList = sortedPortfolioList.filter(portfolio =>
    portfolio.name.toLowerCase().includes(searchTerm) || portfolio.type.toLowerCase().includes(searchTerm)
  );


  return (
    <Modal
      title="Manage User Portfolios"
      visible={visible}
      onOk={onClose} // You might want to handle saving the selected portfolios here
      onCancel={onClose}
    >
      <Space>
        <Input
          placeholder="Search portfolios..."
          onChange={(e) => handleSearch(e.target.value)}
          style={{ marginBottom: 16 }}
        />
      </Space>
      <Table
        columns={columns}
        dataSource={filteredAndSortedPortfolioList || []}
        rowKey="id"
        pagination={false}
      />
    </Modal>
  );
};

export default UserPortfolioManager;
